module.exports = __webpack_public_path__ + "static/media/annie-spratt-c6mdgjKg_hE-unsplash.42eaa38b.jpg";